module.exports = __webpack_public_path__ + "img/logo_alphaday.40181c66.png";